/**
 * Created by anthony on 11/20/14.
 */
var applicationsSubNavbar = angular.module('applicationsSubNavbar', ['classy', 'determineAward']);